<template>
  <div class="NavegacaoRegistros text-right">
    <div class="NavegacaoRegistros_body d-inline-flex">
      <button class="btn-navegacao mt-2"
              @click="mudarMes(-1)">
        <IconSvg class="icon--sm icon_setas"
                 icon="duplaEsquerda" />
      </button>
      <button class="btn-navegacao mt-2"
              @click="mudarOsDias (-1)">
        <IconSvg class="icon--sm icon_setas"
                 icon="esquerda" />
      </button>

      <div v-if="caixa.ultimoCaixa"
           class="NavegacaoRegistros_body d-inline-flex mr-2 ml-1 pr-2 pl-2 border border-dark rounded">
        <span class="caixa-title pt-2 pb-1 font-weight-bold"> Sem caixa {{ dataAtual }} </span>
      </div>
      <div v-else
           class="NavegacaoRegistros_body d-inline-flex mr-2 ml-1 pr-2 pl-2 border border-dark rounded">
        <span class="caixa-title pt-2 pb-1 font-weight-bold">Caixa {{ ' nº ' + caixa.numero + ' | ' + dataAtual }} </span>
      </div>
      <button class="btn-navegacao mt-2"
              @click="mudarOsDias (1)">
        <IconSvg class="icon--sm icon_setas"
                 icon="direita" />
      </button>
      <button class="btn-navegacao mt-2"
              @click="mudarMes(1)">
        <IconSvg class="icon--sm icon_setas"
                 icon="duplaDireita" />
      </button>
    </div>
  </div>
</template>

<script>
  // Importes
  import moment  from "moment"

  export default {
    name: "FiltragemPorData",
    data () {
      return {
        dataAtual: '',
        dataAdpter: '',
        dataMes: '',
        dataAbertura: '',
      }
    },
    computed: {
      cxData () {
        return this.$store.state.frenteCaixa.cxData
      },
      caixa () {
        return this.$store.state.frenteCaixa.caixa
      }
    },
    watch: {
      cxData () {
        this.dataAtual = moment(this.cxData, 'YYYY-MM-DD').format('DD/MM/YYYY')
      }
    },
    created () {
      const date = moment()
      this.dataAdpter = date

      const dataStore = moment(date).format('YYYY-MM-DD')
      this.$store.dispatch('frenteCaixa/atualizarCxData', dataStore)

      this.dataAtual = moment(this.cxData, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    methods: {
      async mudarOsDias (dias) {
        const date = this.dataAdpter
        date.add(dias, 'd')
        const dataStore = moment(date).format('YYYY-MM-DD')
        this.$store.dispatch('frenteCaixa/atualizarCxData', dataStore)
      },
      mudarMes (qt) {
        const date = this.dataAdpter
        date.add(qt, 'M')
        
        const dataStore = moment(date).format('YYYY-MM-DD')
        this.$store.dispatch('frenteCaixa/atualizarCxData', dataStore)
      },
    }
  }
</script>

<style >


  .btn-navegacao {
    width: 35px;
    height: 30px;
    margin: 5px 5px 0 0;
    border-radius: 4px;
    border: solid 1px #086aae;
    background-color: #ffffff;
    color: #074f7f;
    font-weight: 500;
    font-size: 15px;
    letter-spacing: -2px;
  }

  .btn-navegacao:hover {
    color:#fff;
    background-color: #074f7f;
  }

  .btn-navegacao:focus {
    outline: 0px;
  }
  .btn-search-navegacao {
    border-radius: 4px;
    border: solid 1px #086aae;
    background-color: #ffffff;
    color: #074f7f;
    font-weight: 500;
    font-size: 15px;
    margin-left: 15px;
  }
  .icon {
    &_setas {
      width: 15px;
      stroke:  #074f7f;
      stroke-width: 1px;
    }
  }
  .caixa-title {
    font-size:1.2rem;
  }
</style>